import { useEffect } from 'react'
import { useAppDispatch } from './redux'
import socketService from '../services/socket'
import type { ReviewNotificationPayload, SocketNotification, SubmissionRequestedNotification } from '@/types'
import { receiveReviewNotification } from '../store/slices/formInstanceSlice'
import { updateEventStatus } from '../store/slices/calendarSlice'
import { CalendarEventStatus } from '@/types'

export const useFormNotifications = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const handler = (payload: SocketNotification) => {
      if (!payload || typeof payload !== 'object') {
        return
      }

      if (payload.type === 'form.review.result' && 'data' in payload) {
        const { instanceId, decision } = (payload as ReviewNotificationPayload).data
        dispatch(
          receiveReviewNotification({
            instanceId,
            decision,
          }),
        )

        const statusMap: Record<string, CalendarEventStatus> = {
          approve: CalendarEventStatus.COMPLETED,
          request_changes: CalendarEventStatus.IN_PROGRESS,
          reject: CalendarEventStatus.PLANNED,
        }

        dispatch(
          updateEventStatus({
            formInstanceId: instanceId,
            status: statusMap[decision] ?? CalendarEventStatus.PLANNED,
          }),
        )
      }

      if (payload.type === 'form.review.requested' && 'data' in payload) {
        const { instanceId } = (payload as SubmissionRequestedNotification).data
        dispatch(
          updateEventStatus({
            formInstanceId: instanceId,
            status: CalendarEventStatus.IN_PROGRESS,
          }),
        )
      }
    }

    const socket = socketService.connect()
    if (socket) {
      socketService.onNotification(handler)
    }

    return () => {
      socketService.offNotification(handler)
    }
  }, [dispatch])
}

export default useFormNotifications
